import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import CheckoutPage from '@/pages/CheckoutPage';
import ReturnPage from '@/pages/ReturnPage';
import ErrorPage from '@/pages/ErrorPage';

function DonePage() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-green-50 rounded-full mx-auto mb-6">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">¡Pago completado!</h2>
        <p className="text-gray-500 text-sm">Sesión: {sessionId ?? '—'}</p>
        <p className="text-gray-400 text-xs mt-2">(Página de éxito del comercio)</p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/sessions/:id" element={<CheckoutPage />} />
      <Route path="/sessions/:id/return" element={<ReturnPage />} />
      <Route path="/done" element={<DonePage />} />
      {/* success/cancel are merchant return URLs — show placeholder pages for local testing */}
      <Route path="/success" element={<DonePage />} />
      <Route path="/cancel" element={<ErrorPage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="*" element={<Navigate to="/error?reason=not_found" replace />} />
    </Routes>
  );
}
